exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".loading{text-align:center;margin-top:20px}.loading .ant-spin-dot{margin:10px auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/App.scss
// module id = 582
// module chunks = 0